module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "service"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.services), function(service) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-object media-left wow fadeInLeft",
      attrs: {
        "data-wow-delay": "0.2s"
      }
    }, [_c('i', {
      class: [service.icon]
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body wow fadeIn"
    }, [_c('h3', {
      staticClass: "media-heading primary"
    }, [_vm._v(_vm._s(service.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(service.info))])])])])
  })], 2), _vm._v(" "), _c('tryBtn')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-6"
  }, [_c('h3', {
    staticStyle: {
      "color": "#96bca5"
    }
  }, [_vm._v("Advanced Services")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#58585a"
    }
  }, [_vm._v("Printer Counters models & features")]), _vm._v(" "), _c('p', [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e76896da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/services.vue
// module id = 758
// module chunks = 0